// extracted by mini-css-extract-plugin
export default {"competencyItem":"vrtNld3wa4bMmenq7yLo","competencyDescription":"k2kL6OP4eh2cc05HvPQ5","competencyIcon":"D7uXJdrdxJ6XNPlrYEMA","comment":"UqxScwf9DbyDP8KEr52W"};